import { memo, useRef, useState } from 'react'
import { Link } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { Logo } from 'src/shared/components/icons/logos/logo'
import InstantMatchButton from 'src/shared/features/home/components/instant-match-button'
import SimpleSidebar from 'src/shared/features/home/components/simple-sidebar'
import { HamburgerIcon } from 'src/shared/features/home/icons/hamburger'
import { useIsMobile } from 'src/shared/hooks/use-mobile'
import { cn } from 'src/shared/utils/cn'

import HeaderAuthIndicator from './header-auth-indicator'
import type { SearchbarHandle } from './search-bar'
import MarketplaceSearchbar from './search-bar'

const MarketplaceHeader = ({ profile = false }: { profile?: boolean }) => {
  const isMobile = useIsMobile()
  const searchbarRef = useRef<SearchbarHandle>(null)
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const showShadow = true

  const onPressLogo = () => {
    searchbarRef.current?.resetForm()
  }

  return (
    <header
      className={cn(
        'fixed top-0 z-50 flex h-[70px] w-screen items-center justify-between bg-white p-5 md:h-[100px] md:px-8',
        showShadow &&
          'border-b-[rgba(216, 216, 214, 0.75)] border-b-[0.5px] shadow-[0px_4px_12px_0px_rgba(27,48,41,0.03)]',
      )}
    >
      <div
        className={cn(
          'mx-auto flex size-full max-w-[calc(1600px-4rem)] items-center justify-between',
          !profile ? 'max-w-[calc(1600px-4rem)]' : 'max-w-[calc(1400px-6rem)]',
        )}
      >
        <div className="flex flex-row items-center gap-4">
          {isMobile && (
            <button onClick={() => setSidebarOpen(true)}>
              <HamburgerIcon className="size-5 text-primary sm:size-6" />
            </button>
          )}
          <div className={cn(isMobile && 'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2')}>
            <Link
              to={paths.root.getHref()}
              className="flex h-full flex-col items-start justify-center gap-2"
              onClick={onPressLogo}
            >
              <Logo className="h-[28px] w-[120px] md:h-[30px] md:w-[155px]" />
            </Link>
          </div>
        </div>
        {!isMobile && <MarketplaceSearchbar ref={searchbarRef} className="mx-3" />}
        <div className="flex flex-row gap-3">
          <InstantMatchButton
            text="Instant Match Me!"
            className="hidden h-[50px] px-6 font-semibold shadow-none lg:block 2xl:px-8"
          />
          <HeaderAuthIndicator />
        </div>
      </div>
      <SimpleSidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
    </header>
  )
}

const MemoizedMarketplaceHeader = memo(MarketplaceHeader)

export default MemoizedMarketplaceHeader
